import { render } from "./QualificationLanguage.vue?vue&type=template&id=319cbdce"
import script from "./QualificationLanguage.vue?vue&type=script&lang=js"
export * from "./QualificationLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__